module.exports = __webpack_public_path__ + "img/xlpt.47706106.png";